import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Admissionform.css';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import logo from '../Images/logo.png';
import Select from 'react-select';
import { useToast } from '../components/Admissionform/ToastManager'; // Update the path accordingly
import axios from 'axios';
import { MdLocationOn, MdFeedback } from 'react-icons/md';
import { BiGitBranch } from 'react-icons/bi';
import { AiOutlineCalendar } from 'react-icons/ai';
import { HiUserGroup } from 'react-icons/hi';
import { IoListCircleOutline } from 'react-icons/io5';

import {
  FiUser,
  FiMail,
  FiPhone,
  FiCalendar,
  FiBook,
  FiHome,
  FiBriefcase,
} from "react-icons/fi";

import {
  FaBriefcase,
  FaGraduationCap,
  FaBookOpen,
  FaCalendarAlt,
  FaShareAlt,
  FaSitemap,
  FaClock, FaUsers,
  FaRupeeSign, FaPercentage,
  FaChalkboard, FaLaptop,
  FaMapMarkerAlt, FaCodeBranch,
  FaUserTie, FaHandHoldingUsd,
  FaCalendarPlus, FaMoneyBillWave,
  FaCreditCard,
  FaReceipt,
  FaUniversity,
  FaCoins,
  FaHourglassHalf,
  FaCalendarDay,
  FaChalkboardTeacher
} from 'react-icons/fa';
const { v4: uuidv4 } = require('uuid');

const educationCourses = {
  Diploma: ['Computer Science', 'Mechanical', 'Civil'],
  UG: ['B.Sc', 'B.Com', 'B.A', 'B.E/B.Tech', 'BCA', 'BBA'],
  PG: ['M.Sc', 'M.Com', 'M.A', 'M.E/M.Tech', 'MCA', 'MBA'],
};

const AdmissionForm = () => {
  const navigate = useNavigate();
  const [showStudentDetails, setShowStudentDetails] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [showAdmission, setShowAdmission] = useState(false);
  const [showCourse, setShowCourse] = useState(false);
  const [locationsData, setLocationsData] = useState({});
  const [coursesData, setCoursesData] = useState({});
  const [courseFeesData, setcourseFeesData] = useState({});
  const [courseDurData, setcourseDurData] = useState({});
  const [adminNames, setAdminNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isGeneratingId, setIsGeneratingId] = useState(false);
  const [trainers, setTrainers] = useState([]);
  const [bdeEmployees, setBdeEmployees] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const { showSuccess, showError, showWarning } = useToast();
  const [formData, setFormData] = useState({
    studentId: '',
    name: '',
    email_Id: '',
    contactNo: '',
    ParentNo: '',
    address: '',
    educationLevel: '',
    educationCourse: '',
    department: "",
    clg_name: '',
    otherDepartment: "",
    otherBatch: "",
    otherEducationLevel: "",
    passedout: '',
    studentStatus: '',
    dob: '',
    source: '',
    courseType: '',
    course: '',
    courseFees: '',
    discountAmount: '',
    classType: '',
    learningMode: '',
    courseDuration: '',
    batch: '',
    demoGivenBy: '',
    demoGivenDate: today,
    adminEmpName: '',
    adminlocation: '',
    adminbranch: '',
    dateOfAdmission: today,
    feesCollected: '',
    bank: '',
    registrationPaymentMode: '',
    registrationReferenceNo: '',
    pendingFees: '',
    pendingFeesDate: '',
    paymentInstallment: '',
    pendingFees2: '',
    pendingFeesDate2: '',
    pendingFees3: '',
    pendingFeesDate3: '',
    pendingFees4: '',
    pendingFeesDate4: '',
    staffAssigned: '',
    studentRequestedLocation: '',
    studentRequestedBranch: '',
    adminFeedback: '',
    placementneeded: '',
    studentRequirement: '',
    sharingBranch: '',
    sharingAdminName: '',
    sharingAmount: '',
    staffAssignedId: '',
    mentor: '',
    mentorid: '',
    mentorNumber: '',
    studentProgressStatus: 'In Progress'
  });

  const sourceOptions = [
    { value: 'Meta', label: 'Meta' },
    { value: 'Website Call', label: 'Website Call' },
    { value: 'Web Form', label: 'Web Form' },
    { value: 'Student Reference', label: 'Student Reference' },
    { value: 'Direct WalkIn', label: 'Direct WalkIn' },
    { value: 'Direct Call', label: 'Direct Call' },
    { value: 'Sulekha', label: 'Sulekha' },
    { value: 'Website Msg', label: 'Website Msg' },
    { value: 'Instagram', label: 'Instagram' },
    { value: 'Youtube', label: 'Youtube' },
    { value: 'LinkedIn', label: 'LinkedIn' },
    { value: 'Google WhatsAPP', label: 'Google WhatsAPP' },
    { value: 'Google AD', label: 'Google AD' },
    { value: 'APNA', label: 'APNA' },
    { value: 'Naukri', label: 'Naukri' },
    { value: 'INDEED', label: 'INDEED' },
    { value: 'HR Job Portal', label: 'HR Job Portal' },
    { value: 'IndiaMART', label: 'IndiaMART' },
    { value: 'Just Dial', label: 'Just Dial' },
    { value: 'MD Reference', label: 'MD Reference' },
    { value: 'Other Reference', label: 'Other Reference' },
  ];
  const handleLocationChange = (e) => {
    const selectedLocation = e.target.value;
    setFormData((prevState) => ({


      ...prevState,
      adminlocation: selectedLocation,
      adminbranch: '', // Reset adminbranch when adminlocation changes
    }));
  };

  useEffect(() => {
    if (formData.adminbranch && !formData.studentId) {
      fetchNextId();
    }
  }, [formData.adminbranch]);

  const branches = [
    'Gandhipuram',
    'Hosur',
    'Poonamallee',
    'Padi',
    'Malumichampatti',
    'Marathahalli',
    'Saravanampatti',
    'Tambaram',
    'Tiruppur',
    'Vadapalani',
    'Velachery',];

  useEffect(() => {
    const fetchBDEEmployees = async () => {
      if (!formData.sharingBranch) return;

      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/bde-employees?branch=${formData.sharingBranch}`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        console.log("BDE Employees:", response.data);
        setBdeEmployees(response.data);
      } catch (error) {
        console.error('Error fetching BDE employees:', error);
      }
    };

    fetchBDEEmployees();
  }, [formData.sharingBranch]);

  // Filter employees based on the selected branch if one is selected
  const filteredEmployees = formData.sharingBranch
    ? bdeEmployees.filter(employee => {
      // If the branch is an array, check if the selected branch is included in it
      if (Array.isArray(employee.branch)) {
        return employee.branch.includes(formData.sharingBranch);
      }
      // If the branch is a string, directly compare it
      return employee.branch === formData.sharingBranch;
    })
    : bdeEmployees; // If no branch is selected, don't filter employees


  const fetchNextId = async (courseTypeOverride = null) => {
    // Use the override value if provided, otherwise use formData
    const courseType = courseTypeOverride || formData.courseType;

    if (!formData.adminbranch || !courseType) {
      console.log("Both branch and course type are required for ID generation");
      return;
    }

    setIsGeneratingId(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/registrations`,
        {
          adminbranch: formData.adminbranch,
          courseType: courseType // Use the potentially overridden value
        },
        {
          params: { preview: 'true' },
          headers: { Authorization: `Bearer ${token}` }
        }
      );

      console.log("Raw API response for ID:", response.data);
      console.log("nextId from API:", response.data.nextId);

      setFormData(prev => ({
        ...prev,
        studentId: response.data.nextId
      }));
    } catch (error) {
      console.error('Error generating ID:', error);
      // Fallback with placeholder
      const courseAbbrev = getCourseTypeAbbreviation(courseType);
      const branchAbbrev = getBranchAbbreviation(formData.adminbranch);

      setFormData(prev => ({
        ...prev,
        studentId: `${courseAbbrev}-${branchAbbrev}-XXXX`
      }));
    } finally {
      setIsGeneratingId(false);
    }
  };

  // Modified handleBranchChange
  const handleBranchChange = async (e) => {
    const selectedBranch = e.target.value;

    setFormData(prev => ({
      ...prev,
      adminbranch: selectedBranch,
    }));

    if (formData.courseType) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/registrations`,
          {
            adminbranch: selectedBranch,
            courseType: formData.courseType
          },
          {
            params: { preview: 'true' },
            headers: { Authorization: `Bearer ${token}` }
          }
        );

        console.log("API returned ID:", response.data.nextId);

        // Just use the ID directly from the backend
        setFormData(prev => ({
          ...prev,
          studentId: response.data.nextId
        }));
      } catch (error) {
        console.error('Error fetching next ID:', error);
        // Only use our fallback pattern if the API call fails
        const courseAbbrev = getCourseTypeAbbreviation(formData.courseType);
        const branchAbbrev = getBranchAbbreviation(selectedBranch);

        setFormData(prev => ({
          ...prev,
          studentId: `${courseAbbrev}-${branchAbbrev}-XXXX`
        }));
      }
    }
  };

  const BRANCH_ABBREVIATIONS = {
    "Tambaram": "TM",
    "Velachery": "VL",
    "Vadapalani": "VP",
    "Poonamallee": "PM",
    "Marathahalli": "MH",
    "Gandhipuram": "GP",
    "Malumichampatti": "MP",
    "Hosur": "HS",
    "Saravanampatti": "SP",
    "Tiruppur": "TP",
    "Padi": "PD",
    // Add more branches as needed
  };

  // Default abbreviation function in case a branch doesn't have a mapping
  const getBranchAbbreviation = (branchName) => {
    if (!branchName) return "UNK"; // Unknown branch

    // Check if we have a predefined abbreviation
    if (BRANCH_ABBREVIATIONS[branchName]) {
      return BRANCH_ABBREVIATIONS[branchName];
    }

    // As a fallback, create an abbreviation from the first 3 letters
    return branchName.substring(0, 2).toUpperCase();
  };

  // Add this mapping at the top with your other constants
  const COURSE_TYPE_ABBREVIATIONS = {
    "CADD": "CD",
    "Pumo Tech IT": "PI", // Fixed: removed the space at the end
    "Pumo Tech Automation": "PA", // Fixed: removed the space at the end
    "Monz Creative School": "MZ", // Fixed: typo in "School"
    // Add more course types as needed
  };

  // Default course type abbreviation function
  const getCourseTypeAbbreviation = (courseType) => {
    if (!courseType) return "CR"; // Default to "Course" if none specified

    // Check if we have a predefined abbreviation
    if (COURSE_TYPE_ABBREVIATIONS[courseType]) {
      return COURSE_TYPE_ABBREVIATIONS[courseType];
    }

    // As a fallback, create an abbreviation from the first 2 letters
    return courseType.substring(0, 2).toUpperCase();
  };

  useEffect(() => {
    const fetchLoggedInUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('No token found!');

        const response = await fetch(`${process.env.REACT_APP_API_URL}/regdetail`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error('Failed to fetch user');

        const data = await response.json();
        console.log("API Response (Logged-In User):", data);

        setAdminNames(Array.isArray(data) ? data : [data]);
      } catch (error) {
        console.error('Error fetching logged-in user:', error);
      }
    };

    fetchLoggedInUser();
  }, []); // ✅ No warning

  // Add this effect to handle course type changes
  useEffect(() => {
    if (formData.courseType && formData.adminbranch && !formData.studentId) {
      fetchNextId();
    } else if (formData.courseType && formData.adminbranch && formData.studentId) {
      // If we already have an ID but the course type changed, regenerate it
      const courseAbbrev = getCourseTypeAbbreviation(formData.courseType);
      const branchAbbrev = getBranchAbbreviation(formData.adminbranch);

      // Check if current ID matches the expected format
      const idParts = formData.studentId.split('-');
      if (idParts.length === 3) {
        const numberId = idParts[2];
        setFormData(prev => ({
          ...prev,
          studentId: `${courseAbbrev}-${branchAbbrev}-${numberId}`
        }));
      } else if (idParts.length === 2) {
        // Handle current format (VLC-1001)
        const numberId = idParts[1];
        setFormData(prev => ({
          ...prev,
          studentId: `${courseAbbrev}-${branchAbbrev}-${numberId}`
        }));
      }
    }
  }, [formData.courseType]);

  useEffect(() => {
    const fetchFilteredEmployees = async () => {
      if (!formData.adminlocation || !formData.adminbranch) return;

      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/regdetail?location=${formData.adminlocation}&branch=${formData.adminbranch}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!response.ok) throw new Error('Failed to fetch employees');

        const data = await response.json();
        console.log("Filtered Employees:", data);

        // Convert to array if data is an object
        const normalizedData = Array.isArray(data) ? data : [data];

        setAdminNames(normalizedData);
      } catch (error) {
        console.error('Error fetching filtered employees:', error);
      }
    };

    fetchFilteredEmployees();
  }, [formData.adminlocation, formData.adminbranch]);

  useEffect(() => {
    // First, modify the fetchTrainers function in the component

    const fetchTrainers = async () => {
      if (!formData.studentRequestedLocation || !formData.studentRequestedBranch) return;

      try {
        const token = localStorage.getItem('token');
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/regdetail?location=${formData.studentRequestedLocation}&branch=${formData.studentRequestedBranch}&role=Trainer`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (!response.ok) throw new Error('Failed to fetch trainers');

        const data = await response.json();
        console.log("Filtered Trainers:", data);

        // Convert to array if data is an object
        const normalizedData = Array.isArray(data) ? data : [data];

        setTrainers(normalizedData);
      } catch (error) {
        console.error('Error fetching trainers:', error);
      }
    };

    fetchTrainers();
  }, [formData.studentRequestedLocation, formData.studentRequestedBranch]);

  useEffect(() => {
    const fetchLoggedInUserLocation = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) throw new Error('No token found!');

        const response = await fetch(`${process.env.REACT_APP_API_URL}/regdetail`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!response.ok) throw new Error('Failed to fetch user');

        const data = await response.json();
        console.log("API Response (Logged-In User Location):", data);

        const userData = Array.isArray(data) ? data : [data];

        const userLocationsData = {};

        userData.forEach(user => {
          if (user.location) {
            // Ensure location is an array
            const locations = Array.isArray(user.location) ? user.location : [user.location];

            locations.forEach(location => {
              if (!userLocationsData[location]) {
                userLocationsData[location] = { branches: [] };
              }

              if (user.branch) {
                if (typeof user.branch === 'string') {
                  const branchParts = user.branch.match(/[A-Z][a-z]+|[^,\s]+/g) || [user.branch];

                  branchParts.forEach(branch => {
                    if (!userLocationsData[location].branches.includes(branch)) {
                      userLocationsData[location].branches.push(branch);
                    }
                  });
                } else if (Array.isArray(user.branch)) {
                  user.branch.forEach(branch => {
                    if (!userLocationsData[location].branches.includes(branch)) {
                      userLocationsData[location].branches.push(branch);
                    }
                  });
                } else {
                  if (!userLocationsData[location].branches.includes(user.branch)) {
                    userLocationsData[location].branches.push(user.branch);
                  }
                }
              }
            });
          }
        });

        console.log("User data received:", userData);
        userData.forEach(user => {
          console.log("Processing user location:", user.location);
          console.log("Processing user branch:", user.branch);
          console.log("Branch type:", typeof user.branch);
        });

        setLocationsData(userLocationsData);

        const userLocations = Object.keys(userLocationsData);
        if (userLocations.length === 1) {
          setFormData(prev => ({
            ...prev,
            adminlocation: userLocations[0],
            studentRequestedLocation: userLocations[0]
          }));

          const branches = userLocationsData[userLocations[0]].branches;
          if (branches.length === 1) {
            setFormData(prev => ({
              ...prev,
              adminbranch: branches[0],
              studentRequestedBranch: branches[0]
            }));
          }
        }
      } catch (error) {
        console.error('Error fetching logged-in user location:', error);
      }
    };
    fetchLoggedInUserLocation();
  }, []);

  const generatePDF = () => {
    return new Promise((resolve) => {
      const doc = new jsPDF();

      // Generate Unique Receipt Number
      const receiptNumber = `117-${uuidv4().replace(/\D/g, '').slice(0, 7)}`;

      const img = new Image();
      img.src = logo;
      img.onload = () => {
        doc.setFont('Times', 'bold');

        // Title: INVOICE RECEIPT
        doc.setFontSize(28);
        doc.text('INVOICE/RECEIPT', 105, 25, { align: 'center' });

        // Receipt Information
        doc.setFontSize(12);
        doc.setFont('Times', 'normal');
        doc.text(`Receipt number: ${receiptNumber}`, 15, 40);
        doc.text(`Date of admission: ${formData?.dateOfAdmission || 'N/A'}`, 15, 50);

        // Add Logo
        const logoWidth = 10, logoHeight = 10;
        doc.addImage(img, 'PNG', 15, 60, logoWidth, logoHeight);

        // Company Information
        doc.setFont('Times', 'bold');
        doc.text('Pumo Technovation', 30, 65);
        doc.setFont('Times', 'normal');
        doc.text(`${formData?.adminbranch || 'N/A'}`, 30, 75);
        doc.text(`${formData?.adminlocation || 'N/A'}`, 30, 80);
        doc.text('info@pumotechnovation.com', 30, 85);

        // Bill To Section
        doc.setFont('Times', 'bold');
        doc.text('Bill To', 140, 65);
        doc.setFont('Times', 'normal');
        doc.text(`${formData?.name || 'N/A'}`, 140, 75);
        doc.text(`${formData?.contactNo || 'N/A'}`, 140, 80);

        // Handle Multi-Line Address
        const address = formData?.address || 'N/A';
        const addressLines = doc.splitTextToSize(address, 60);
        doc.text(`Address: ${addressLines[0]}`, 140, 85);
        if (addressLines.length > 1) {
          for (let i = 1; i < addressLines.length; i++) {
            doc.text(addressLines[i], 140, 85 + (i * 5));
          }
        }

        // ✅ Define CGST & SGST
        const feesCollected = parseFloat(formData.feesCollected) || 0;
        const cgstAmount = feesCollected * 0.09; // 9% CGST
        const sgstAmount = feesCollected * 0.09; // 9% SGST

        // ✅ Calculate finalAmount as feesCollected - (CGST + SGST)
        const finalAmount = feesCollected - (cgstAmount + sgstAmount);

        // Table Rows for PDF Generation
        const tableRows = [
          ["Course", formData?.course || 'N/A'],
          ["Mode of Payment", formData?.registrationPaymentMode || 'N/A'],
        ];

        // Conditionally add fields based on payment mode
        if (formData.registrationPaymentMode !== 'Cash') {
          tableRows.push(
            ["Reference No", formData?.registrationReferenceNo || 'N/A'],
            ["Amount", `${finalAmount.toFixed(2)}`],
            ["CGST (9%)", `${cgstAmount.toFixed(2)}`],
            ["SGST (9%)", `${sgstAmount.toFixed(2)}`]
          );
        }

        tableRows.push(
          ["Fees Collected", `${feesCollected.toFixed(2)}`],
          ["Pending Fees", formData?.pendingFees || 'N/A'],
          ["Pending Fees Date", formData?.pendingFeesDate || 'N/A']
        );

        // Generate Table
        doc.autoTable({
          head: [["Description", "Details"]],
          body: tableRows,
          startY: 120,
          theme: 'grid',
          styles: {
            fillColor: false,
            textColor: [0, 0, 0],
            fontStyle: 'normal',
            fontSize: 12,
            lineWidth: 0.5,
            lineColor: [0, 0, 0],
            font: 'times'
          },
          headStyles: {
            fillColor: false,
            textColor: [0, 0, 0],
            fontStyle: 'bold',
            font: 'times'
          },
          bodyStyles: {
            fillColor: false,
            textColor: [0, 0, 0]
          }
        });


        const finalY = doc.lastAutoTable.finalY + 20;
        doc.setFont('Times', 'italic');
        doc.text("*****This invoice is generated automatically*****", 105, finalY, { align: 'center' });

        // Save PDF
        doc.save(`invoice-receipt-${formData?.name}.pdf`);

        // ✅ Resolve the promise with the generated receipt number
        resolve(receiptNumber);
      };
    });
  };
  const [showReference, setShowReference] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => {
      const updatedState = {
        ...prevState,
        [name]: value,
      };

      // 🧠 Auto-fill emp_id when staff name is selected
      if (name === "staffAssigned") {
        const selectedStaff = trainers.find(t => t.emp_name === value);
        updatedState.staffAssignedId = selectedStaff?.emp_id || "";

        // NEW: Auto-fill mentor fields when staff is assigned
        updatedState.mentor = selectedStaff?.emp_name || "";
        updatedState.mentorid = selectedStaff?.emp_id || "";
        updatedState.mentorNumber = selectedStaff?.contact_num || "";
      }

      // Clear otherDepartment if department changes and is NOT "Others"
      if (name === "department" && value !== "Others") {
        updatedState.otherDepartment = "";
      }

      // Reset educationCourse when educationLevel changes
      if (name === "educationLevel") {
        updatedState.educationCourse = "";
      }

      // Handle payment installment selection
      if (name === 'paymentInstallment') {
        if (value === '1') {
          updatedState.pendingFees2 = '';
          updatedState.pendingFeesDate2 = '';
          updatedState.pendingFees3 = '';
          updatedState.pendingFeesDate3 = '';
          updatedState.pendingFees4 = '';
          updatedState.pendingFeesDate4 = '';
        } else if (value === '2') {
          updatedState.pendingFees3 = '';
          updatedState.pendingFeesDate3 = '';
          updatedState.pendingFees4 = '';
          updatedState.pendingFeesDate4 = '';
        } else if (value === '3') {
          updatedState.pendingFees4 = '';
          updatedState.pendingFeesDate4 = '';
        }
      }

      return updatedState;
    });

    // Show reference for specific payment modes
    if (name === "registrationPaymentMode") {
      setShowReference(
        ["UPI", "Card Payments", "Loan"].includes(value)
      );
    }
  };


  const formatDate = (date) => {
    if (!date) return null; // Ensure there's a valid date
    const parsedDate = new Date(date);
    return isNaN(parsedDate) ? null : parsedDate.toISOString().split("T")[0]; // YYYY-MM-DD format
  };

  const token = localStorage.getItem("token"); // Retrieve token from storage

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!token) {
        showError("You are not logged in. Please log in again.");
        return;
      }

      // Decode the JWT token
      const decodedToken = parseJwt(token);
      console.log("🔍 Decoded JWT Payload:", decodedToken);

      const empId = decodedToken?.emp_id;
      if (!empId) {
        throw new Error("Invalid token: emp_id not found.");
      }
      console.log("👤 Using Employee ID:", empId);

      // Determine the correct department
      const finalDepartment = formData.department === "Others"
        ? formData.otherDepartment
        : formData.department;

      const finalBatchValue = formData.batch === "Others" ? formData.otherBatch : formData.batch;

      const finalEducationLevel = formData.educationLevel === "Others"
        ? formData.otherEducationLevel
        : formData.educationLevel;

      // Format date fields
      const formattedFormData = {
        ...formData,
        department: finalDepartment,
        batch: finalBatchValue,
        educationLevel: finalEducationLevel,
        dob: formatDate(formData.dob),
        demoGivenDate: formatDate(formData.demoGivenDate),
        dateOfAdmission: formatDate(formData.dateOfAdmission),
        pendingFeesDate: formatDate(formData.pendingFeesDate),
        studentId: "",// Clear studentId to let backend generate it
        sharingBranch: formData.sharingBranch || null,
        sharingAdminName: formData.sharingAdminName || null,
        sharingAmount: formData.sharingAmount || null
      };

      // ✅ Clean up optional fields: convert empty strings to null
      ['pendingFees2', 'pendingFeesDate2', 'pendingFees3', 'pendingFeesDate3', 'pendingFees4', 'pendingFeesDate4'].forEach((key) => {
        if (formattedFormData[key] === '') {
          formattedFormData[key] = null;
        }
      });

      // ✅ Send student registration request
      const registrationResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/registrations`,
        formattedFormData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("📄 Registration API Response:", registrationResponse.data);

      const generatedStudentId = registrationResponse.data.student.studentId;

      if (!generatedStudentId) {
        throw new Error("Registration successful but no student ID was returned");
      }

      // Generate PDF & Get Receipt Number
      const receiptNumber = await generatePDF();

      // ✅ Prepare Invoice Data
      const feesCollected = parseFloat(formData.feesCollected) || 0;
      const cgstAmount = feesCollected * 0.09;
      const sgstAmount = feesCollected * 0.09;
      const baseAmount = feesCollected * 0.82;

      const invoiceData = {
        EmpId: empId,
        studentId: generatedStudentId,
        receipt_no: receiptNumber,
        registrationPaymentMode: formData?.registrationPaymentMode || "N/A",
        registrationReferenceNo: formData?.registrationPaymentMode === 'Cash' ? '' : (formData?.registrationReferenceNo || "N/A"),
        amount: formData?.registrationPaymentMode === 'Cash' ? 0 : baseAmount,
        cgst: formData?.registrationPaymentMode === 'Cash' ? 0 : cgstAmount,
        sgst: formData?.registrationPaymentMode === 'Cash' ? 0 : sgstAmount,
        bank: formData.bank || "N/A",
        paymentInstallment: 1,
        paidAmount: formattedFormData.feesCollected,
        paymentDate: formData.dateOfAdmission,
      };

      console.log("🧾 Invoice Data:", invoiceData);

      // ✅ Send invoice request
      const invoiceResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/invoices`,
        invoiceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Invoice API Response:", invoiceResponse.data);

      // ✅ Send student-record request
      const studentRecordData = {
        studentId: generatedStudentId,
        studentName: formattedFormData.name,
        clgName: formattedFormData.clg_name,
        studentContactNumber: formattedFormData.contactNo,
        educationQualification: formattedFormData.educationCourse,
        courseType: formattedFormData.courseType,
        courseName: formattedFormData.course,
        staffId1: formattedFormData.staffAssignedId,
        staffName1: formattedFormData.staffAssigned,
        experience: formattedFormData.studentStatus,
        batch: formattedFormData.batch,
        learningMode: formattedFormData.learningMode,
        branch: formattedFormData.studentRequestedBranch,
        placementneeded: formattedFormData.placementneeded,
        ProgressStatus: formattedFormData.studentProgressStatus,
        placementneeded: formattedFormData.placementneeded,
        email_Id: formattedFormData.email_Id,
        mentor: formattedFormData.mentor,
        mentorid: formattedFormData.mentorid,
        mentorNumber: formattedFormData.mentorNumber
      };

      const studentRecordResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/student-record`,
        studentRecordData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("📘 Student Record API Response:", studentRecordResponse.data);

      // UPDATED: Replace alert with success toast
      showSuccess("Admission & Invoice submitted successfully!");
      navigate("/dashboard");
    } catch (error) {
      console.error("❌ Error submitting form:", error);
      // UPDATED: Replace alert with error toast
      const backendMessage = error.response?.data?.message;

      if (
        backendMessage?.startsWith("This email") ||
        backendMessage?.startsWith("This contact number")
      ) {
        showWarning(backendMessage);
      } else {
        showError(backendMessage || "There was an error submitting the form. Please try again.");
      }

    }
  };

  // ✅ Helper to parse JWT token
  const parseJwt = (token) => {
    try {
      const decoded = JSON.parse(atob(token.split(".")[1]));
      console.log(" Decoded JWT Payload:", decoded);
      return decoded;
    } catch (error) {
      console.error(" Error parsing token:", error);
      return {};
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  const handleCourseTypeChange = (e) => {
    const selectedCourseType = e.target.value;

    setFormData((prevState) => ({
      ...prevState,
      courseType: selectedCourseType,
      course: '',  // Reset course when courseType changes
      courseFees: '',
      courseDuration: '',
    }));

    // If we have a branch selected, regenerate the ID immediately
    if (formData.adminbranch) {
      // Use a brief timeout to ensure state has updated
      setTimeout(() => {
        // Use the selected value directly rather than relying on state
        fetchNextId(selectedCourseType);
      }, 0);
    }
  };

  const handleCourseChange = (e) => {
    const selectedCourse = e.target.value;

    // Find the corresponding course details safely
    const courseDetails = courseFeesData[selectedCourse] || null;
    const courseDet = courseDurData[selectedCourse] || null;

    setFormData((prevState) => ({
      ...prevState,
      course: selectedCourse,
      courseFees: courseDetails ?? "", // Default to empty string only if undefined/null
      courseDuration: courseDet ?? "" // Ensure empty if no course selected
    }));
  };

  useEffect(() => {
    const fetchAllLocationsData = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/location`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // Transform the API response into the format you need
        const formattedLocations = {};
        response.data.forEach(location => {
          if (!formattedLocations[location.location]) {
            formattedLocations[location.location] = { branches: [] };
          }
          formattedLocations[location.location].branches.push(location.branch);
        });

        // Store all locations for student requested fields
        console.log("All locations data:", formattedLocations);
      } catch (error) {
        console.error("Error fetching all locations:", error);
      }
    };

    const fetchCourseData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/course`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        // Transform course data
        const coursesByType = {};
        const Fees = {};
        const Dur = {};

        response.data.forEach(course => {
          // Initialize course type array if not exists
          if (!coursesByType[course.courseType]) {
            coursesByType[course.courseType] = [];
          }

          // Add course name to the appropriate course type
          if (!coursesByType[course.courseType].includes(course.courseName)) {
            coursesByType[course.courseType].push(course.courseName);
          }

          // Store course fees
          Fees[course.courseName] = course.courseFees;
          Dur[course.courseName] = course.courseDuration;

        });

        setCoursesData(coursesByType);
        setcourseFeesData(Fees);
        setcourseDurData(Dur);

      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchAllLocationsData();
    fetchCourseData();
  }, [token]);

  useEffect(() => {
    const courseFees = parseFloat(formData.courseFees) || 0;
    const discountAmount = parseFloat(formData.discountAmount) || 0;
    const balanceFee = courseFees - discountAmount;

    setFormData((prevState) => ({
      ...prevState,
      balanceFee: balanceFee >= 0 ? balanceFee : 0,
    }));
  }, [formData.courseFees, formData.discountAmount]);

  useEffect(() => {
    const balanceFee = parseFloat(formData.balanceFee) || 0;
    const feesCollected = parseFloat(formData.feesCollected) || 0;
    const pendingFees2 = parseFloat(formData.pendingFees2) || 0;
    const pendingFees3 = parseFloat(formData.pendingFees3) || 0;
    const pendingFees4 = parseFloat(formData.pendingFees4) || 0;
    const pendingFees = balanceFee - (pendingFees2 + pendingFees3 + pendingFees4) - feesCollected;

    setFormData((prevState) => ({
      ...prevState,
      pendingFees: pendingFees >= 0 ? pendingFees : 0,
    }));
  }, [formData.balanceFee, formData.feesCollected, formData.pendingFees2, formData.pendingFees3, formData.pendingFees4])


  const toggleStudentDetails = () => {
    setShowStudentDetails(!showStudentDetails);
  };

  const toggleAdmin = () => {
    setShowAdmin(!showAdmin);
  };

  const toggleAdmission = () => {
    setShowAdmission(!showAdmission);
  };

  const toggleCourse = () => {
    setShowCourse(!showCourse);
  };

  // Function to auto-fill student form based on contact number
  const autoFillStudentData = async (contactNo) => {
    if (!contactNo || contactNo.trim() === '') {
      console.log('Contact number is required for auto-fill');
      return;
    }

    setLoading(true);  // Show loading indicator

    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/students/${contactNo}`);
      console.log('API Response:', response.data); // Log the response data

      if (response.status === 404) {
        console.log('No student found with this contact number. You can enter details manually.');
        setFormData((prevData) => ({
          ...prevData,
          name: '',
          email_Id: '',
          address: '',
          // Reset other fields if necessary
        }));
        return;
      }

      // Extract student data
      const studentData = response.data.data;
      let updatedFormData = {
        ...studentData,
        adminbranch: studentData.branch || '',
        courseType: studentData.courseType || 'N/A',
        course: studentData.course || '',
      };

      // Fetch course details if course and courseType are available
      if (studentData.course && studentData.courseType) {
        try {
          const courseResponse = await axios.get(`${process.env.REACT_APP_API_URL}/courses/${studentData.course}/${studentData.courseType}`);
          const courseData = courseResponse.data;
          updatedFormData.courseFees = courseData.courseFees || 'N/A';
          updatedFormData.courseDuration = courseData.courseDuration || 'N/A';
        } catch (courseError) {
          console.error('Failed to fetch course details:', courseError);
          updatedFormData.courseFees = 'N/A';
          updatedFormData.courseDuration = 'N/A';
        }
      }

      // Update form data
      setFormData((prevData) => ({
        ...prevData,
        ...updatedFormData
      }));

      console.log('Student data loaded successfully');
    } catch (error) {
      console.error('Failed to fetch student data:', error);
    } finally {
      setLoading(false);  // Hide loading indicator
    }
  };

  // Handle contactNo change
  const handleContactNoBlur = () => {
    const contactNo = formData.contactNo;
    if (contactNo) {
      autoFillStudentData(contactNo);
    }
  };

  useEffect(() => {
    // You could use the contact number to auto-fill when the form is first loaded if desired.
    if (formData.contactNo) {
      autoFillStudentData(formData.contactNo);
    }
  }, [formData.contactNo]);

  return (
    <div className='bg'>
      <div className="admission-form-container">
        <h1>
          <div className="logo1">
            <img src="Images/logo.png" alt="PUMO TECHNOVATION" />
          </div>
          PUMO TECHNOVATION</h1>

        <h3>ENROLLMENT FORM</h3>
        <form onSubmit={handleSubmit}>
          {/* Personal Information */}
          <div className='form-section'>
            <div
              className="section-header"
              onClick={toggleStudentDetails}
            >
              <h4>Student Details</h4>
              <span className="dropdownaf-arrow">
                {showStudentDetails ? '▼' : '▶'}
              </span>
            </div>
            {showStudentDetails && (
              <div className="section-content">
                {loading && <div>Loading...</div>}
                <div className="form-row">
                  <div className="form-field">
                    <input
                      type="text"
                      name="studentId"
                      value={
                        isGeneratingId
                          ? "Generating..."
                          : formData.studentId ||
                          "Select Branch and Course Type..."
                      }
                      readOnly
                    />
                    <label>
                      <FiBook
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Registration ID: <span className="mandatory">*</span>
                    </label>
                  </div>

                  <div className="form-field">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <label>
                      <FiUser
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Name:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <input
                      type="email"
                      name="email_Id"
                      value={formData.email_Id}
                      onChange={handleChange}
                      required
                    />
                    <label>
                      <FiMail
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Email Id:<span className="mandatory">*</span>
                    </label>
                  </div>
                  <div className="form-field">
                    <input
                      type="text"
                      name="contactNo"
                      value={formData.contactNo}
                      onChange={(e) => {
                        // Allow only digits and limit to 10
                        const value = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setFormData({ ...formData, contactNo: value });
                      }}
                      onBlur={handleContactNoBlur}
                      min="0"
                      maxLength={10}
                      title="Please enter a valid 10-digit contact number"
                      required
                    />
                    <label>
                      <FiPhone
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Contact Number:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">
                    <select
                      name="studentStatus"
                      value={formData.studentStatus}
                      onChange={handleChange}
                      required
                    >
                      <option value={""}>Choose Student status</option>
                      <option value={"Student"}>Student</option>
                      <option value={"Fresher"}>Fresher</option>
                      <option value={"Internship"}>Internship</option>
                      <option value={"Working Experience"}>
                        Working Experience 0-1years
                      </option>
                      <option value={"Working Experience 1-2"}>
                        Working Experience 1-2years
                      </option>
                      <option value={"Working Experience 2-3"}>
                        Working Experience 2-3years
                      </option>
                      <option value={"Working Experience 3-4"}>
                        Working Experience 3-4years
                      </option>
                      <option value={"Working Experience 4-5"}>
                        Working Experience 4-5years
                      </option>
                      <option value={"Working Experience 5-6"}>
                        Working Experience 5-6years
                      </option>
                      <option value={"Working Experience 6-7"}>
                        Working Experience 6-7years
                      </option>
                      <option value={"Working Experience 7-8"}>
                        Working Experience 7-8years
                      </option>
                      <option value={"Working Experience 8-9"}>
                        Working Experience 8-9years
                      </option>
                      <option value={"Working Experience 9-10"}>
                        Working Experience 9-10years
                      </option>
                      <option value={"Working Experience >10"}>
                        Working Experience more than 10years
                      </option>
                    </select>

                    <label>
                      <FiBriefcase
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Student Status:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      required
                    />
                    <label>
                      <FiCalendar
                        style={{ marginRight: "6px", verticalAlign: "middle" }}
                      />
                      Date of Birth:<span className="mandatory">*</span>
                    </label>
                  </div>

                  <div className="form-field">
                    <Select
                      name="source"
                      options={sourceOptions}
                      value={sourceOptions.find(
                        (option) => option.value === formData.source
                      )}
                      onChange={(selectedOption) =>
                        handleChange({
                          target: {
                            name: "source",
                            value: selectedOption?.value,
                          },
                        })
                      }
                      placeholder="Choose Your Source"
                      isSearchable
                      required
                    />
                    <label>
                      <FaShareAlt style={{ marginRight: '5px' }} />
                      Source:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>

                <div className="form-field">
                  <select
                    name="placementneeded"
                    value={formData.placementneeded}
                    onChange={handleChange}
                  >
                    <option>Do you need Placement</option>
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                  <label>
                    <FaBriefcase style={{ marginRight: '5px' }} />
                    Placement Needed:<span className="mandatory">*</span>
                  </label>
                </div>
              </div>
            )}

          </div>

          <div className='form-section'>
            <div
              className="section-header"
              onClick={toggleCourse}
            >
              <h4>Course</h4>
              <span className="dropdownaf-arrow">
                {showCourse ? '▼' : '▶'}
              </span>
            </div>
            {showCourse && (
              <div className="section-content">
                <div className="form-row">
                  <div className="form-field">
                    <select
                      name="courseType"
                      value={formData.courseType}
                      onChange={handleCourseTypeChange}
                      required
                    >
                      <option value="">Select Course Type</option>
                      {Object.keys(coursesData).map((courseType) => (
                        <option key={courseType} value={courseType}>
                          {courseType}
                        </option>
                      ))}
                    </select>
                    <label>
                      <FaGraduationCap style={{ marginRight: '5px' }} />
                      Course Type:<span className="mandatory">*</span>
                    </label>
                  </div>

                  {/* Course */}
                  {formData.courseType && coursesData[formData.courseType] && (
                    <div className="form-field">
                      {formData.courseType === "Others" ? (
                        <input
                          type="text"
                          name="course"
                          value={formData.course}
                          onChange={handleChange}
                          placeholder="Enter course name"
                          required
                        />
                      ) : (
                        <Select
                          name="course"
                          options={coursesData[formData.courseType].map(
                            (course) => ({
                              value: course,
                              label: course,
                            })
                          )}
                          value={
                            formData.course
                              ? {
                                value: formData.course,
                                label: formData.course,
                              }
                              : null
                          }
                          onChange={(selectedOption) =>
                            handleCourseChange({
                              target: {
                                name: "course",
                                value: selectedOption?.value || "",
                              },
                            })
                          }
                          placeholder="Select Course"
                          isSearchable
                          required
                        />
                      )}
                      <label>
                        <FaBookOpen style={{ marginRight: '5px' }} />
                        Course: <span className="mandatory">*</span>
                      </label>
                    </div>
                  )}
                </div>
                <div className="form-row">
                  {formData.course && (
                    <div className="form-field">

                      <input
                        type="text"
                        name="courseDuration"
                        value={formData.courseDuration}
                        readOnly
                        className="readonly-input"
                      />
                      <label>
                        <FaClock style={{ marginRight: '5px' }} />
                        Course Duration (Hours):{" "}
                        <span className="mandatory">*</span>
                      </label>
                    </div>
                  )}

                  <div className="form-field">

                  </div>
                </div>

                <div className="form-row">
                  <div className="form-field">

                    <input
                      type="number"
                      name="courseFees"
                      value={formData.courseFees}
                      onChange={handleChange}
                      placeholder="Enter course fees"
                      readOnly={formData.studentStatus !== "Internship"} // Only editable for Internship
                      required
                      className={
                        formData.studentStatus === "Internship"
                          ? ""
                          : "readonly-input"
                      }
                    />
                    <label>
                      <FaRupeeSign style={{ marginRight: '5px' }} />
                      Course Fees:<span className="mandatory">*</span>
                    </label>
                  </div>
                  <div className="form-field">

                    <input
                      type="number"
                      name="discountAmount"
                      value={formData.discountAmount}
                      min="0"
                      onChange={handleChange}
                    />
                    <label>
                      <FaPercentage style={{ marginRight: '5px' }} />
                      Discount Amount:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>

              </div>

            )}
          </div>

          <div className='form-section'>
            <div
              className="section-header"
              onClick={toggleAdmission}
            >
              <h4>Admission Details</h4>
              <span className="dropdownaf-arrow">
                {showAdmission ? '▼' : '▶'}
              </span>
            </div>
            {showAdmission && (
              <div className="section-content">
                {/* Admin Location */}
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="adminlocation"
                      value={formData.adminlocation}
                      onChange={handleLocationChange}
                      required
                    >
                      <option value="">Select Admin Location</option>
                      {Object.keys(locationsData).map((location) => (
                        <option key={location} value={location}>
                          {location}
                        </option>
                      ))}
                    </select><label>
                      <FaMapMarkerAlt style={{ marginRight: '5px' }} />
                      Admin Location:<span className="mandatory">*</span>
                    </label>
                  </div>

                  {/* Admin Branch (Always Visible) */}
                  <div className="form-field">

                    <select
                      name="adminbranch"
                      value={formData.adminbranch}
                      onChange={handleBranchChange}
                      required
                      disabled={!formData.adminlocation} // Disable until location is selected
                    >
                      <option value="">Select Admin Branch</option>
                      {formData.adminlocation &&
                        locationsData[formData.adminlocation]?.branches.map(
                          (branch, index) => (
                            <option key={`branch-${index}`} value={branch}>
                              {branch}
                            </option>
                          )
                        )}
                    </select><label>
                      <FaCodeBranch style={{ marginRight: '5px' }} />
                      Admin Branch:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>

                {/* Admin Name (Always Visible) */}
                <div className="form-row">
                  <div className="form-field">


                    <select
                      name="adminEmpName"
                      value={formData.adminEmpName}
                      onChange={handleChange}
                      required
                      disabled={!formData.adminbranch} // Disable until branch is selected
                    >
                      <option value="">Select Admin Name</option>
                      {Array.isArray(adminNames) && adminNames.length > 0 ? (
                        adminNames
                          .filter((admin) => admin.role?.toLowerCase() === "bde")
                          .map((admin) => (
                            <option key={admin.emp_id} value={admin.emp_name}>
                              {admin.emp_name}
                            </option>
                          ))
                      ) : (
                        <option>No Data...</option>
                      )}
                    </select><label>
                      <FaUserTie style={{ marginRight: '5px' }} />
                      Admin Name:<span className="mandatory">*</span>
                    </label>
                  </div>

                  {/* Add this to the Admin Information section */}
                  <div className="form-field">

                    <select
                      name="sharingBranch"
                      value={formData.sharingBranch}
                      onChange={handleChange}
                    >
                      <option value="">Select Branch</option>
                      {branches.map((branch) => (
                        <option key={branch} value={branch}>
                          {branch}
                        </option>
                      ))}
                    </select><label>
                      <BiGitBranch style={{ marginRight: '5px' }} />Sharing Branch:</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="sharingAdminName"
                      value={formData.sharingAdminName}
                      onChange={handleChange}
                      disabled={!formData.sharingBranch}
                    >
                      <option value="">Select Admin</option>
                      {filteredEmployees.map((employee) => (
                        <option key={employee.emp_id} value={employee.emp_name}>
                          {employee.emp_name}
                        </option>
                      ))}
                    </select><label>
                      <FaUserTie style={{ marginRight: '5px' }} />
                      Sharing Admin Name:</label>
                  </div>

                  <div className="form-field">

                    <input
                      type="number"
                      name="sharingAmount"
                      value={formData.sharingAmount}
                      onChange={handleChange}
                      disabled={!formData.sharingAdminName}
                      min="0"
                    /><label>
                      <FaHandHoldingUsd style={{ marginRight: '5px' }} />
                      Sharing Amount:</label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">

                    <input
                      type="date"
                      name="dateOfAdmission"
                      value={formData.dateOfAdmission}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split("T")[0]} // ✅ Limit to today
                    /><label>
                      <FaCalendarPlus style={{ marginRight: '5px' }} />
                      Date of Admission:<span className="mandatory">*</span>
                    </label>
                  </div>

                  <div className="form-field">

                    <input
                      type="number"
                      name="feesCollected"
                      value={formData.feesCollected}
                      min="0"
                      onChange={handleChange}
                    /><label>
                      <FaMoneyBillWave style={{ marginRight: '5px' }} />
                      Fees Collected:<span className="mandatory">*</span>
                    </label>
                  </div></div>
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="registrationPaymentMode"
                      value={formData.registrationPaymentMode}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Payment Mode</option>
                      <option value="Cash">Cash</option>
                      <option value="Card Payments">Card Payments</option>
                      <option value="UPI">UPI</option>
                      <option value="Loan">Loan Process</option>
                    </select><label>
                      <FaCreditCard style={{ marginRight: '5px' }} />
                      Payment Mode:<span className="mandatory">*</span>
                    </label>
                  </div>
                  {showReference && (
                    <div className="form-field">

                      <input
                        type="text"
                        name="registrationReferenceNo"
                        value={formData.registrationReferenceNo}
                        onChange={handleChange}
                        required
                      /><label>
                        <FaReceipt style={{ marginRight: '5px' }} />
                        Transaction No.:</label>
                    </div>
                  )}</div>
                <div className="form-row">
                  {showReference && (

                    <div className="form-field">

                      <select
                        name="bank"
                        value={formData.bank}
                        onChange={handleChange}
                        required
                      >
                        <option>Choose Bank Details</option>
                        <option>YES Bank - (MMP Br)</option>
                        <option>YES Bank - (HOS Br) </option>
                        <option>DBS Bank - (BLR Br)</option>
                        <option>HDFC Bank - (CBE Br)</option>
                        <option>HDFC Bank - (TPR Br)</option>
                        <option>Icici Bank - (CBE Br)</option>
                        <option>Icici Bank - (TBM Br)</option>
                        <option>Icici Bank - (VCH Br)</option>
                        <option>Icici Bank - (VDP Br)</option>
                        <option>Loan - (Chennai Icici)</option>
                        <option>Loan - (CBE HDFC)</option>
                        <option>Loan - (HOS YES)</option>
                        <option>YES Bank - (CBE Gpm Br)</option>
                        <option>Kotak Bank - (CBE Gpm Br)</option>
                        <option>South Indian Bank - (SRP Ganapathy Br)</option>
                      </select><label>
                        <FaUniversity style={{ marginRight: '5px' }} />
                        Bank Details :<span className="mandatory">*</span>
                      </label>
                    </div>
                  )}

                  <div className="form-field">

                    <select
                      name="paymentInstallment"
                      value={formData.paymentInstallment}
                      onChange={handleChange}
                      required
                    >
                      <option value="1">1st Installment</option>
                      <option value="2">2nd Installment</option>
                      <option value="3">3rd Installment</option>
                      <option value="4">4th Installment</option>
                    </select><label>
                      <FaCoins style={{ marginRight: '5px' }} />
                      Payment Installment:<span className="mandatory">*</span>
                    </label>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-field">

                    <input
                      type="number"
                      name="pendingFees"
                      value={formData.pendingFees}
                      readOnly
                      className="readonly-input"
                    /><label>
                      <FaHourglassHalf style={{ marginRight: '5px' }} />
                      Pending Fees 1: </label>
                  </div>
                  <div className="form-field">

                    <input
                      type="date"
                      name="pendingFeesDate"
                      value={formData.pendingFeesDate}
                      onChange={handleChange}
                    /><label>
                      <FaCalendarDay style={{ marginRight: '5px' }} />
                      Pending Fees Date 1:{" "}
                      {parseFloat(formData.pendingFees) !== 0 && (
                        <span className="mandatory">*</span>
                      )}
                    </label>
                  </div>
                </div>
                {formData.paymentInstallment === "2" ||
                  formData.paymentInstallment === "3" ||
                  formData.paymentInstallment === "4" ? (
                  <>
                    <div className="form-row">
                      <div className="form-field">

                        <input
                          type="number"
                          name="pendingFees2"
                          value={formData.pendingFees2}
                          onChange={handleChange}
                          placeholder="Enter 2nd installment pending fees"
                        /><label>
                          <FaHourglassHalf style={{ marginRight: '5px' }} />
                          Pending Fees 2: </label>
                      </div>
                      <div className="form-field">

                        <input
                          type="date"
                          name="pendingFeesDate2"
                          value={formData.pendingFeesDate2}
                          min="0"
                          onChange={handleChange}
                          required={["2", "3", "4"].includes(
                            formData.paymentInstallment
                          )}
                        /><label>
                          <FaCalendarDay style={{ marginRight: '5px' }} />
                          Pending Fees Date 2:{" "}
                          <span className="mandatory">*</span>
                        </label>
                      </div></div>
                  </>
                ) : null}
                {formData.paymentInstallment === "3" ||
                  formData.paymentInstallment === "4" ? (
                  <>
                    <div className="form-row">
                      <div className="form-field">

                        <input
                          type="number"
                          name="pendingFees3"
                          value={formData.pendingFees3}
                          min="0"
                          onChange={handleChange}
                          placeholder="Enter 3rd installment pending fees"
                        /><label>
                          <FaHourglassHalf style={{ marginRight: '5px' }} />
                          Pending Fees 3: </label>
                      </div>
                      <div className="form-field">

                        <input
                          type="date"
                          name="pendingFeesDate3"
                          value={formData.pendingFeesDate3}
                          onChange={handleChange}
                          required={["3", "4"].includes(
                            formData.paymentInstallment
                          )}
                        /><label>
                          <FaCalendarDay style={{ marginRight: '5px' }} />
                          Pending Fees Date 3:{" "}
                          <span className="mandatory">*</span>
                        </label>
                      </div></div>
                  </>
                ) : null}
                {formData.paymentInstallment === "4" ? (
                  <>
                    <div className="form-row">
                      <div className="form-field">

                        <input
                          type="number"
                          name="pendingFees4"
                          value={formData.pendingFees4}
                          onChange={handleChange}
                          placeholder="Enter 4th installment pending fees"
                        /><label>
                          <FaHourglassHalf style={{ marginRight: '5px' }} />
                          Pending Fees 4: </label>
                      </div>
                      <div className="form-field">

                        <input
                          type="date"
                          name="pendingFeesDate4"
                          value={formData.pendingFeesDate4}
                          onChange={handleChange}
                          required={formData.paymentInstallment === "4"}
                        /><label>
                          <FaCalendarDay style={{ marginRight: '5px' }} />
                          Pending Fees Date 4:{" "}
                          <span className="mandatory">*</span>
                        </label>
                      </div></div>
                  </>
                ) : null}
              </div>
            )}
          </div>

          <div className='form-section'>
            <div
              className="section-header"
              onClick={toggleAdmin}
            >
              <h4>Staff & Student Overview</h4>
              <span className="dropdownaf-arrow">
                {showAdmin ? '▼' : '▶'}
              </span>
            </div>
            {showAdmin && (
              <div className="section-content">
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="studentRequestedLocation"
                      value={formData.studentRequestedLocation}
                      onChange={(e) => {
                        const selectedLocation = e.target.value;
                        setFormData((prevState) => ({
                          ...prevState,
                          studentRequestedLocation: selectedLocation,
                          studentRequestedBranch: "",
                        }));
                      }}
                      required
                    >
                      <option value="">Select Student req Location</option>
                      {/* Changed from allLocationsData to locationsData to only show user's locations */}
                      {Object.keys(locationsData).map((location) => (
                        <option key={location} value={location}>
                          {location}
                        </option>
                      ))}
                    </select><label>
                      <MdLocationOn style={{ marginRight: '5px' }} />
                      Student Requested location:
                      <span className="mandatory">*</span>
                    </label>
                  </div>

                  {formData.studentRequestedLocation &&
                    locationsData[formData.studentRequestedLocation] && (
                      <div className="form-field">

                        <select
                          name="studentRequestedBranch"
                          value={formData.studentRequestedBranch}
                          onChange={(e) => {
                            const selectedBranch = e.target.value;
                            setFormData((prevState) => ({
                              ...prevState,
                              studentRequestedBranch: selectedBranch,
                            }));
                          }}
                          required
                        >
                          <option value="">Select req Branch</option>
                          {/* Changed from allLocationsData to locationsData to only show user's branches */}
                          {locationsData[
                            formData.studentRequestedLocation
                          ].branches.map((branch) => (
                            <option key={branch} value={branch}>
                              {branch}
                            </option>
                          ))}
                        </select><label>
                          <BiGitBranch style={{ marginRight: '5px' }} />
                          Student Requested Branch:
                          <span className="mandatory">*</span>
                        </label>
                      </div>
                    )}</div>
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="demoGivenBy"
                      value={formData.demoGivenBy}
                      onChange={handleChange}
                    >
                      <option value="">Select Demo Given By</option>
                      {Array.isArray(trainers) && trainers.length > 0 ? (
                        trainers
                          .filter(
                            (staff) => staff.role?.toLowerCase() === "trainer"
                          )
                          .map((staff) => (
                            <option key={staff.emp_id} value={staff.emp_name}>
                              {staff.emp_name}
                            </option>
                          ))
                      ) : (
                        <option>No Data...</option>
                      )}
                    </select><label>
                      <FaChalkboardTeacher style={{ marginRight: '5px' }} />
                      Demo Given By:</label>
                  </div>
                  <div className="form-field">

                    <input
                      type="date"
                      name="demoGivenDate"
                      value={formData.demoGivenDate}
                      onChange={handleChange}
                      max={new Date().toISOString().split("T")[0]} // ✅ Limit to today
                    /><label>
                      <AiOutlineCalendar style={{ marginRight: '5px' }} />
                      Demo Given Date:</label>
                  </div></div>
                <div className="form-row">
                  <div className="form-field">

                    <select
                      name="staffAssigned"
                      value={formData.staffAssigned}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select Staff</option>
                      {Array.isArray(trainers) && trainers.length > 0 ? (
                        trainers
                          .filter(
                            (staff) => staff.role?.toLowerCase() === "trainer"
                          )
                          .map((staff) => (
                            <option key={staff.emp_id} value={staff.emp_name}>
                              {staff.emp_name}
                            </option>
                          ))
                      ) : (
                        <option>No Data...</option>
                      )}
                    </select><label>
                      <HiUserGroup style={{ marginRight: '5px' }} />
                      Staff Assigned:<span className="mandatory">*</span>
                    </label>
                  </div>

                  <div className="form-field">

                    <textarea
                      name="adminFeedback"
                      value={formData.adminFeedback}
                      onChange={handleChange}
                    /><label><MdFeedback style={{ marginRight: '5px' }} />
                      Admin Feedback:</label>
                  </div></div>
                <div className="form-row">
                  <div className="form-field">

                    <textarea
                      name="studentRequirement"
                      value={formData.studentRequirement}
                      onChange={handleChange}
                    /><label>
                      <IoListCircleOutline style={{ marginRight: '5px' }} />
                      Student Requirement:</label>
                  </div></div>
              </div>
            )}
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-btn">Submit</button>
            <button type="button" className="cancel-btn" onClick={handleCancel}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdmissionForm;